import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/paint-calculator',
  component: () => import('../../routes/PaintCalculator.svelte'),
  card: {
    id: 'paint-calculator',
    title: 'Paint Calculator',
    description: 'Calculate how much paint you need for your room. Estimate gallons, cost, and coverage for any painting project.',
    icon: 'format_paint',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/paint-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Paint Calculator – Estimate Gallons and Cost for Your Room',
    description: 'Free paint calculator to estimate how many gallons of paint you need for any room. Calculate total cost, coverage area, and number of coats.',
  },
};

export default meta;
